import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-density-vertical',
  standalone: false,
  templateUrl: './density-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class DensityVerticalComponent {
@Input() densityTest:any
ngOnInit() {
}
}

